module.exports = __webpack_public_path__ + "img/symbol_8.a1e81e82.png";